import {useContext} from "react";
import {ResponseStatus, StatusContextData} from "../../context/status";


export default function StatusMessage() {
    const {messageQueue} = useContext(StatusContextData);
    const fadeOutTime = 1000;

    return <div className={"status-message-queue"}>
        {messageQueue?.map((message, index) => {
            return <FloatingMessage key={index} type={message.type} content={message.content}
                                    style={message.duration > 0 ? {
                                        animation: `fadeOut ${fadeOutTime / 1000}s forwards`,
                                        animationDelay: `${(message.duration - fadeOutTime) / 1000}s`
                                    } : {}}/>
        })}
    </div>
}

function FloatingMessage({type, content, ...props}) {
    switch (type) {
        case ResponseStatus.PENDING:
            return <div className="status loading" {...props}>
                <div className="icon loader-1 center"><span></span></div>
                <div>{content}</div>
            </div>
        case ResponseStatus.RESOLVED:
            return <div className="status success" {...props}>
                <i className="icon fas fa-check-circle fa-2x"></i>
                <div>{content}</div>
            </div>
        case ResponseStatus.ERROR:
            return <div className="status status-error" {...props}>
                <i className="icon fas fa-stop-circle-o fa-2x"></i>
                <div>{content}</div>
            </div>
    }
}